import type { TAnswers } from 'models/common.model'

export const getImplicitBehaviorIssuesK9Bl = (
  savedAnswers: Partial<TAnswers> | null | undefined,
): string[] => {
  if (!savedAnswers) return []

  const leashRaw = savedAnswers.leash_pulling_k9_bl
  const leash = Array.isArray(leashRaw) ? leashRaw[0] : leashRaw

  return [
    ...(leash === 'yes' || leash === 'sometimes' ? ['leash_pulling'] : []),
  ]
}
